import {
  OrganizationAccessTabs,
  OrganizationAccountTabs,
  OrganizationAuthTabs,
  OrganizationSecurityTabs,
} from "./types";

export const pathConfig = {
  [OrganizationAccessTabs.USERS]: "users",
  [OrganizationAccessTabs.IDP_GROUP_MAPPING]: "idp-group-mapping",
  [OrganizationAccessTabs.API_KEYS]: "api-keys",
  [OrganizationAccessTabs.SPACES]: "spaces",
  [OrganizationAccessTabs.LOGIN_POLICIES]: "login-policy",
  [OrganizationAccessTabs.ROLES]: "roles",
  [OrganizationAccessTabs.MANAGEMENT_STRATEGY]: "management-strategy",
  [OrganizationAuthTabs.SSO]: "sso",
  [OrganizationAuthTabs.MFA]: "mfa",
  [OrganizationSecurityTabs.SECURITY_EMAIL]: "security",
  [OrganizationSecurityTabs.SESSIONS]: "sessions",
  [OrganizationSecurityTabs.RUNTIME_SECURITY]: "runtime-security",
  [OrganizationSecurityTabs.OIDC_SUBJECT_TEMPLATE]: "oidc-subject-template",
  [OrganizationSecurityTabs.OAUTH_REDIRECT_ALLOWLIST]: "oauth-redirect-allowlist",
  [OrganizationAccountTabs.BILLING]: "billing",
  [OrganizationAccountTabs.LIMITS]: "limits",
  [OrganizationAccountTabs.USAGE]: "usage",
  [OrganizationAccountTabs.USAGE_EXPORT]: "usage-export",
  [OrganizationAccountTabs.AI]: "ai",
  [OrganizationAccountTabs.FLOWS]: "flows",
  [OrganizationAccountTabs.ACCOUNT_DELETION]: "account-deletion",
};

export const SPACE_ADMIN_ROLE_SLUG = "space-admin";
